var App = App || {};

App.Base = (function ($) {
    'use strict';

    let bsElements = {};

    let modals = [];
    let modalFlag = false;

    const speedBump = $("#SpeedBump");
    let speedBumpExempt = typeof SpeedbumpData !== 'undefined' ? [...SpeedbumpData.ExemptList] : [];

    const investmentsNotice = $("#InvestmentsNotice");
    let investmentsNoticePages = typeof InvestmentsNoticeData !== 'undefined' ? [...InvestmentsNoticeData.PagesList] : [];

    function Autofocus() {
        ["shown.bs.modal", "shown.bs.offcanvas"].forEach(function (eventName) {
            document.addEventListener(eventName, function (event) {
                var targetElement = event.target;
                var autofocusElement = targetElement.querySelector("[autofocus]");

                if (autofocusElement) {
                    autofocusElement.focus();
                }
            });
        });
    }

    function BsElements() {

        bsElements = {
            accElements: [...$("[data-bs-toggle='collapse']")].filter(x => x.getAttribute("data-bs-target") != "").map(x => x.getAttribute("data-bs-target")),
            tabElements: [...$("[data-bs-toggle='tab']")].filter(x => x.getAttribute("id") != "").map(x => `#${x.getAttribute("id")}`),
            offcanvasElements: [...$(".offcanvas")].filter(x => x.getAttribute("id") != "").map(x => `#${x.getAttribute("id")}`)
        };

        const hash = location.hash;
        BsElementsExecute(hash);
    }

    function BsElementsExecute(candidate) {

        let bsType = false;

        for (const key in bsElements) {
            if (bsElements[key].includes(candidate)) {
                bsType = key;
            }
        }

        if (bsType == false)
            return false;

        if (bsType == "accElements") {
            const collapse = $(candidate);
            collapse.collapse("show").parents(".accordion-item").find(`[data-bs-target=\"${candidate}\"]`).trigger("focus");
            $("html, body").animate({ scrollTop: collapse.offset().top }, 200);
        }
        else if (bsType == "tabElements") {
            const tab = $(candidate);
            tab.tab("show").trigger("focus");
            $("html, body").animate({ scrollTop: tab.offset().top }, 200);
        }
        else if (bsType == "offcanvasElements") {
            const offcanvas = $(candidate);
            offcanvas.offcanvas("show");
        }

        return true;
    }

    function BsPopovers() {
        const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
        const popoverList = [...popoverTriggerList].map(popoverTriggerEl => {
            const contentId = popoverTriggerEl.getAttribute('data-bs-content-id');
            const options = { html: true };
            
            if (contentId) {
                const contentElement = document.getElementById(contentId);
                if (contentElement) {
                    options.content = contentElement.innerHTML;
                }
            }
            
            return new bootstrap.Popover(popoverTriggerEl, options);
        })
    }

    function BsTooltips() {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
    };

    function ClickSupport(selector) {

        selector.on("click", function (e) {

            const href = $(this).attr("href");

            if (CopyToClipboardExecute($(this)) == true) {
                e.preventDefault();
                return false;
            }

            if (BsElementsExecute(href) == true)
                return false;

            if (ModalsExecute(href, $(this)) == true) {
                e.preventDefault();
                return false;
            }

            if (InvestmentsNoticeExecute($(this)) == true) {
                e.preventDefault();
                return false;
            }

            if (SpeedBumpExecute($(this)) == true) {
                e.preventDefault();
                return false;
            }
        });
    }

    function CopyToClipboardExecute(clicked) {
        if (!clicked.hasClass("copy")) {
            return false;
        }

        const textToCopy = clicked.text().trim();

        if (!textToCopy) {
            return false;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy).then(function() {
                ShowCopyFeedback(clicked);
            }).catch(function(err) {
                console.error("Failed to copy: ", err);
            });
        } else {
            const textArea = document.createElement("textarea");

            textArea.value = textToCopy;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";

            document.body.appendChild(textArea);
            textArea.select();

            try {
                document.execCommand('copy');
                ShowCopyFeedback(clicked);
            } catch (err) {
                console.error("Failed to copy: ", err);
            }

            document.body.removeChild(textArea);
        }

        return true;
    }

    function ShowCopyFeedback(element) {
        const originalTitle = element.attr("title") || "";
        const tooltipInstance = bootstrap.Tooltip.getInstance(element[0]);

        if (tooltipInstance) {
            tooltipInstance.dispose();
        }

        element.attr("data-bs-original-title", "Copied!")
               .attr("title", "Copied!");

        const tooltip = new bootstrap.Tooltip(element[0], {
            trigger: "manual"
        });

        tooltip.show();

        setTimeout(function() {
            tooltip.hide();

            setTimeout(function() {
                tooltip.dispose();

                if (originalTitle) {
                    element.attr("title", originalTitle);
                } else {
                    element.removeAttr("title").removeAttr("data-bs-original-title");
                }
            }, 200);
        }, 1500);
    }

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    function IsUriSchema(href) {

        const uriSchemes = ["javascript:", "mailto:", "tel:"];

        for (var i in uriSchemes) {
            if (href.indexOf(uriSchemes[i]) > -1) {
                return true;
            }
        }
        return false;
    }

    function Modals() {

        $.ajax({
            type: "GET",
            url: "/Api/Modals/GetModalUrls",
            success: function (result) {
                modals = [...result];
                const href = location.hash.replace("#", "/").toLowerCase();
                ModalsExecute(href, null);
            }
        })
    }

    function ModalsExecute(href, clicked) {

        const siteTourCookie = App.Cookies.getItem("Web5_SiteTour");

        if (href !== "" && modals.includes(href))
            href = href;
        else if (href === "" && siteTourCookie !== "closed")
            href = "/site-tour";
        else
            return false;

        $.ajax({
            type: "GET",
            url: href,
            success: function (result) {

                const modalData = {
                    "id": $(result).filter(".modal").attr("id"),
                    "content": $(result).filter(".modal").prop("outerHTML")
                };

                $("body").append(modalData.content);
                const modal = $(`#${modalData.id}`);

                App.Base.ClickSupport(modal.find("a"));

                setTimeout(function() {
                    modal.modal("show").on("hidden.bs.modal", function () {
                        if (clicked !== null) {
                            clicked.trigger("focus").trigger("blur");
                        }
                        if (!modalFlag) {
                            $(this).remove();
                        }
                    });
                }, 0);

            }
        });

        return true;
    }

    function RichTextResponsiveTables(selector) {
        selector.each(function () {
            var $this = $(this);

            if (!$this.hasClass("table")) {
                if (!$this.parents(".rich-text").hasClass("fs-sm")) {
                    $this.addClass("table text-center");
                }
            }

            if (!$this.parent().hasClass("table-responsive")) {
                $this.wrap("<div class=\"table-responsive\"></div>")
            }
        });
    }

    function ShowNoticeModal(modal, proceedButtonSelector, href, clicked, openInNewTab = false) {
        // check to see if notice was triggered from a modal
        const modalParent = clicked.parents(".modal").first();
        modalFlag = modalParent.length != 0;
        modalParent.modal("hide");

        setTimeout(function() {
            modal.modal("show");
            modal.find(proceedButtonSelector)
                .off("click")
                .on("click", function () {
                    modal.modal("hide");
                    if (openInNewTab) {
                        window.open(href);
                    } else {
                        window.location.href = href;
                    }
                });

            modal.on("hidden.bs.modal", function () {
                clicked.trigger("focus").trigger("blur");
                if (modalFlag) {
                    modalParent.modal("show");
                    modalFlag = false;
                }
            });
        }, 0);
    }

    function InvestmentsNoticeExecute(clicked) {
        const href = clicked.attr("href");

        if (!href || !investmentsNoticePages.length) {
            return false;
        }

        const normalizedHref = href.toLowerCase().replace(/\/$/, '');
        const isMatch = investmentsNoticePages.some(page => {
            const normalizedPage = page.toLowerCase().replace(/\/$/, '');
            return normalizedHref === normalizedPage || normalizedHref.endsWith(normalizedPage);
        });

        if (!isMatch) {
            return false;
        }

        ShowNoticeModal(investmentsNotice, "button[data-investments-notice='proceed']", href, clicked, false);
        return true;
    }

    function SpeedBumpExecute(clicked) {
        const hostname = clicked[0].hostname;
        const href = clicked.attr("href");

        if (hostname === location.hostname || $.inArray(hostname, speedBumpExempt) !== -1 || !href || IsUriSchema(href)) {
            return false;
        }

        ShowNoticeModal(speedBump, "button[data-speedbump='proceed']", href, clicked, true);
        return true;
    }

    function ThemeInit() {
        $(".theme-default").on("click", function(e) {
            e.preventDefault();

            ThemeSet("default");
        });

        $(".theme-investments").on("click", function (e) {
            e.preventDefault();

            ThemeSet("investments");
        });
    }

    function ThemeSet(theme) {
        const htmlElement = document.documentElement;
        const pageBranding = htmlElement.getAttribute("data-page-branding");
        
        if (pageBranding === "investments") {
            return;
        }
        
        if (theme === "investments") {
            htmlElement.setAttribute("data-bs-theme", "investments");
            localStorage.setItem("Web5_Theme", "investments");
        } else {
            htmlElement.removeAttribute("data-bs-theme");
            localStorage.setItem("Web5_Theme", "default");
        }
    }

    function ThemeLoad() {
        const htmlElement = document.documentElement;
        const pageBranding = htmlElement.getAttribute("data-page-branding");
        
        if (pageBranding === "investments") {
            return;
        }
        
        const savedTheme = localStorage.getItem("Web5_Theme");

        if (savedTheme) {
            if (savedTheme === "investments") {
                htmlElement.setAttribute("data-bs-theme", "investments");
            } else {
                htmlElement.removeAttribute("data-bs-theme");
            }
        }
    }

    function Year() {
        var $year = $(".year");

        $.each($year, function () {
            var $this = $(this),
                year = new Date().getFullYear();

            $this.text(year);
        });
    }

    return {
        Autofocus: Autofocus,
        BsElements: BsElements,
        BsPopovers: BsPopovers,
        BsTooltips: BsTooltips,
        ClickSupport: ClickSupport,
        GetUrlParameter: GetUrlParameter,
        Modals: Modals,
        RichTextResponsiveTables: RichTextResponsiveTables,
        ThemeInit: ThemeInit,
        ThemeLoad: ThemeLoad,
        ThemeSet: ThemeSet,
        Year: Year
    };

})(jQuery);

$(function () {
    App.Base.Autofocus();
    App.Base.BsElements();
    App.Base.BsPopovers();
    App.Base.BsTooltips();
    App.Base.ClickSupport($("a"));
    App.Base.Modals();
    App.Base.RichTextResponsiveTables($(".rich-text table"));
    App.Base.ThemeLoad();
    App.Base.ThemeInit();
    App.Base.Year();
});